function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Morse utils v4.3.0 by A Stainforth
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("@djforth/cookie_mgmt_fp"), require("lodash/uniqueId")) : "function" == typeof define && define.amd ? define(["exports", "@djforth/cookie_mgmt_fp", "lodash/uniqueId"], t) : t((e = e || self).MorseUtils = {}, e.CookieMgmt, e.uniqueId);
}(this, function (e, t, n) {
  "use strict";

  function r(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var n = [],
          r = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, u = e[Symbol.iterator](); !(r = (i = u.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          r || null == u["return"] || u["return"]();
        } finally {
          if (o) throw a;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function o(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }

        return n;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  t = t && t.hasOwnProperty("default") ? t["default"] : t, n = n && n.hasOwnProperty("default") ? n["default"] : n;

  var a = function a(e, t) {
    var n = {
      Array: Array.isArray,
      Boolean: function Boolean(e) {
        return "boolean" == typeof e;
      },
      Element: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        return e instanceof Element;
      }),
      Number: function Number(e) {
        return "number" == typeof e;
      },
      String: function String(e) {
        return "string" == typeof e;
      }
    };
    if (!n.hasOwnProperty(e)) return !1;

    var r = function (e, t) {
      switch (e) {
        case "Element":
          return document.getElementById(t);

        case "String":
          return t;

        default:
          try {
            return JSON.parse(t);
          } catch (e) {
            return null;
          }

      }
    }(e, t);

    return (0, n[e])(r);
  },
      i = function i(e) {
    return function (t) {
      var n, i;
      return !(!t && !t.attributes) && !!function (e) {
        return e.reduce(function (e, t) {
          return !!e || (t.nodeName ? !!t.nodeName.match(/data/) : e);
        }, !1);
      }(o(t.attributes)) && (n = Object.keys(t.dataset), (i = Object.keys(e).reduce(function (e, t) {
        return !!e && n.includes(t);
      }, !0)) ? Object.entries(e).reduce(function (e, n) {
        var o = r(n, 2),
            i = o[0],
            u = o[1];
        return e ? a(u, t.dataset[i]) : e;
      }, !0) : i);
    };
  },
      u = function u(e) {
    return e instanceof Element;
  };

  function c(e, t) {
    if (!u(e)) return null;
    var n = e.parentNode || document.body;
    if (!u(n)) return null;
    n.removeChild(e), function (e) {
      return "function" == typeof e;
    }(t) && t(e);
  }

  var l = function l(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    e && (e.setAttribute("aria-hidden", "true"), e.style.display = "none", t && c(e));
  },
      d = function d(e) {
    var t = e.dataset.alert;
    return {
      alert: document.getElementById(t),
      id: t
    };
  },
      s = function s() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "alerts",
        n = t(e),
        r = n.getValue(),
        o = r ? JSON.parse(n.getValue()) : [];
    return {
      cookie: n,
      closed: o
    };
  },
      f = function f() {
    return o(document.querySelectorAll("[data-alert]")).map(function (e) {
      var t = d(e),
          n = t.alert,
          r = t.id;
      return l(n), r;
    });
  },
      m = function m(e) {
    return function (t) {
      var n = t.target;
      e.forEach(function (e) {
        var r = e.check,
            o = e.trigger;
        if (r(n)) o(n, t);else {
          var a = function e(t, n) {
            return n === document.body ? null : t(n.parentNode) ? n.parentNode : n.parentNode === document.body ? null : e(t, n.parentNode);
          }(r, n);

          a && o(a, t);
        }
      });
    };
  };

  var g = function g(e) {
    return {
      close: document.getElementById(e.dataset.closeModal),
      lastFocus: document.activeElement,
      modal: document.getElementById(e.dataset.modal)
    };
  },
      v = function v(e, t) {
    return document.getElementById(e.dataset[t]);
  };

  e.AlertClose = function (e) {
    var t = s(e),
        n = t.cookie,
        r = t.closed;
    return r.length > 0 && function (e) {
      var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      e.forEach(function (e) {
        c(document.getElementById(e), t);
      });
    }(r), {
      check: i({
        alert: "Element"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault(), e.setAttribute("aria-pressed", "true");
        var o = d(e),
            a = o.alert,
            i = o.id;
        l(a, !1), r.push(i), n.createCookie(JSON.stringify(r), 365);
      }
    };
  }, e.AlertReset = function () {
    var e = t("alerts");
    return {
      check: i({
        alertsReset: "Boolean"
      }),
      trigger: function trigger(t, n) {
        n.preventDefault(), e.deleteCookie(), document.location.reload();
      }
    };
  }, e.AlertsClear = function (e) {
    var t = s(e),
        n = t.cookie,
        r = t.closed;
    return r.length > 0 && f(), {
      check: i({
        alertsClear: "Boolean"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault();
        var o = r.concat(f());
        n.createCookie(JSON.stringify(o), 365);
      }
    };
  }, e.Checker = i, e.Cookiebar = function (e) {
    var n = t("permission");
    return n.getValue() && c(document.getElementById(e)), {
      check: i({
        cookiebar: "Element"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault(), function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          e && (e.setAttribute("aria-hidden", "true"), e.style.display = "none", t && c(e));
        }(document.getElementById(e.dataset.cookiebar)), n.createCookie(!0, 365);
      }
    };
  }, e.EventListener = function (e) {
    if (!Array.isArray(e)) throw new Error("Must be array");
    var t = m(e);
    return document.body.addEventListener("click", t, !1), function () {
      document.body.removeEventListener("click", t, !1);
    };
  }, e.ImageViewer = function () {
    return {
      check: i({
        imageViewer: "Boolean"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault(), e.focus();

        var r = function (e) {
          return {
            alt: e.getAttribute("alt"),
            imageLarge: e.dataset.imageLarge,
            modalClass: e.dataset.modalClass
          };
        }(e),
            o = r.alt,
            a = r.imageLarge,
            i = r.modalClass,
            u = n("imageViewer");

        document.body.insertAdjacentHTML("beforeend", function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              r = arguments.length > 3 ? arguments[3] : void 0;
          return '<section class="modal-overlay '.concat(n, '" id="').concat(t, '" aria-hidden="false" role="dialog" tabindex="1">\n    <div class="modal-content">\n      <button id="').concat(t, '-close" class="close-btn clearfix">x</button>\n      <div class="modal-content-image">\n        <img src="').concat(e, '" alt="').concat(r, '" />\n      </div>\n    </div>\n  </section>');
        }(a, u, i, o));
        var c = document.getElementById(u);
        c.focus(), function (e, t) {
          e.addEventListener("click", t);
        }(document.getElementById("".concat(u, "-close")), function (e, t) {
          return function (n) {
            n.preventDefault(), n.target.removeEventListener("click", n.target), e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1"), e.parentElement.removeChild(e), t.focus();
          };
        }(c, e));
      }
    };
  }, e.Modal = function () {
    var e = document.querySelector("[data-modal]");

    if (e) {
      var t = g(e).modal;
      t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"), t.setAttribute("role", "dialog");
    }

    return {
      check: i({
        modal: "Element",
        closeModal: "Element"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault();
        var n = g(e),
            r = n.close,
            o = n.lastFocus,
            a = n.modal;
        !function (e) {
          e.setAttribute("aria-hidden", "false"), e.setAttribute("tabindex", "0"), e.focus();
        }(a), function (e, t) {
          e.addEventListener("click", t);
        }(r, function (e, t) {
          return function (n) {
            n.preventDefault(), n.target.removeEventListener("click", n.target), e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", "-1"), t.focus();
          };
        }(a, o));
      }
    };
  }, e.MoreLess = function () {
    return {
      check: i({
        more: "Element",
        less: "Element"
      }),
      trigger: function trigger(e, t) {
        t.preventDefault();

        var n = v(e, "more"),
            r = v(e, "less"),
            o = function (e) {
          var t = "true" === e.getAttribute("aria-pressed");
          return e.setAttribute("aria-pressed", !t), e.textContent = t ? "Read More" : "Read Less", t;
        }(e);

        n.setAttribute("aria-hidden", o), r.setAttribute("aria-hidden", !o);
      }
    };
  }, e.RemoveElement = c, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});